export const useOmniaPreviewMode = () => {
  return useCookie<boolean>("preview");
};
